//src/admin/pages/AdminRemoveSale.js
import React, { useEffect, useState } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import {
  getAdminProducts,
  getAdminCategoriesWithProducts,
  removeProductsFromSale,
} from "../../services/adminProducts.api";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaCheckCircle, FaTimes } from "react-icons/fa";

export default function AdminRemoveSale() {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [selected, setSelected] = useState([]);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    getAdminProducts().then((data) => {
      setProducts(data.filter((p) => p.on_sale));
    });

    getAdminCategoriesWithProducts().then(setCategories);
  }, []);

  const filtered = products.filter((p) => {
    const q = search.toLowerCase();

    const matchSearch =
      (p.name_en || "").toLowerCase().includes(q) ||
      (p.public_id || "").toLowerCase().includes(q);

    const productCategories = Array.isArray(p.categories)
      ? p.categories
      : [];

    const matchCategory = !category || productCategories.includes(category);

    return matchSearch && matchCategory;
  });

  const toggle = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const removeSale = async () => {
    if (!selected.length) return;

    try {
      await removeProductsFromSale(selected);

      setToast({
        type: "success",
        text: "Sale removed successfully ✅",
      });

      setProducts((prev) => prev.filter((p) => !selected.includes(p.id)));
      setSelected([]);

      setTimeout(() => setToast(null), 2500);
    } catch {
      setToast({
        type: "error",
        text: "Failed to remove sale",
      });
      setTimeout(() => setToast(null), 3000);
    }
  };

  return (
    <div className="flex bg-gray-100 min-h-screen">
      <AdminSidebar />
      <div className="flex-1 lg:ml-64">
        <AdminHeader />

        <main className="p-6 space-y-4">
          <div className="flex justify-between items-center">
            <button
              onClick={() => navigate("/admin/products/on-sale")}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-white border shadow-sm"
            >
              <FaArrowLeft /> Back
            </button>

            <div className="text-sm text-gray-500">
              Showing {filtered.length} on-sale products
            </div>
          </div>

          {toast && (
            <div className="fixed top-5 right-5 z-50 bg-white border rounded-xl shadow px-4 py-3 flex gap-3">
              {toast.type === "success" ? (
                <FaCheckCircle className="text-green-600" />
              ) : (
                <FaTimes className="text-red-600" />
              )}
              <span>{toast.text}</span>
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input
              className="p-3 border rounded-xl"
              placeholder="Search by name or ID"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <select
              className="p-3 border rounded-xl"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">All categories</option>
              {categories.map((c) => (
                <option key={c.id} value={c.slug}>
                  {c.name_en}
                </option>
              ))}
            </select>

            <button
              onClick={removeSale}
              className="bg-gray-800 hover:bg-black text-white rounded-xl font-bold"
            >
              Remove Sale
            </button>
          </div>

          <div className="bg-white rounded-xl shadow overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-200">
                <tr>
                  <th className="p-3"></th>
                  <th className="p-3">Name</th>
                  <th className="p-3">Public ID</th>
                  <th className="p-3">Sale %</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((p) => (
                  <tr key={p.id} className="border-b">
                    <td className="p-3 text-center">
                      <input
                        type="checkbox"
                        checked={selected.includes(p.id)}
                        onChange={() => toggle(p.id)}
                      />
                    </td>
                    <td className="p-3">{p.name_en}</td>
                    <td className="p-3">{p.public_id}</td>
                    <td className="p-3 text-red-600 font-bold">
                      {p.sale_percent}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  );
}

